import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const TableCassinos = ({ cassinos }) => {
    return (
        <Box mt={2}>
            <Paper elevation={0}>
                <TableContainer component={Paper} elevation={0}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell>Id</TableCell> */}
                                <TableCell>Cassino</TableCell>
                                <TableCell>AuthKey</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cassinos.map((item) => (
                                <TableRow key={item.id}>
                                    {/* <TableCell>{item.id}</TableCell> */}
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>
                                        <IconButton aria-label="delete" onClick={() => { navigator.clipboard.writeText(item.authKey) }}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                        {item.authKey}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    )
}
export default TableCassinos;